import './About.css';

function About() {
  return (
    <div className="about">

      {/* HERO */}
      <section className="about-hero">
        <div className="about-hero-inner">
          <div className="a-tag">About Us</div>
          <h1>Empowering India to <span>Learn, Trade & Invest</span></h1>
          <div className="gold-line"></div>
          <p>The Atharva Veda Equity is a knowledge-first financial education platform built for every Indian who wants to understand the stock market, build wealth and achieve financial independence.</p>
        </div>
      </section>

      {/* STATS */}
      <section className="a-stats">
        <div className="a-stat">
          <div className="a-stat-num">100+</div>
          <div className="a-stat-label">People Mentored & Clients</div>
        </div>
        <div className="a-stat-divider"></div>
        <div className="a-stat">
          <div className="a-stat-num">SEBI</div>
          <div className="a-stat-label">Regulated Curriculum</div>
        </div>
        <div className="a-stat-divider"></div>
        <div className="a-stat">
          <div className="a-stat-num">NISM</div>
          <div className="a-stat-label">Certified Educator</div>
        </div>
        <div className="a-stat-divider"></div>
        <div className="a-stat">
          <div className="a-stat-num">IRDAI</div>
          <div className="a-stat-label">Certified Advisor</div>
        </div>
        <div className="a-stat-divider"></div>
        <div className="a-stat">
          <div className="a-stat-num">5 Yrs</div>
          <div className="a-stat-label">Market Experience</div>
        </div>
      </section>

      {/* WHO WE ARE */}
      <section className="a-section">
        <div className="a-section-inner">
          <div className="a-section-left">
            <div className="a-tag">Who we are</div>
            <h2 className="a-title">Our Story & Mission</h2>
            <div className="a-gold-line"></div>
            <p className="a-text">The Atharva Veda Equity was founded with a single belief — that financial knowledge should not be limited to the privileged few. Every person deserves to understand how markets work, how to grow their money and make informed investment decisions.</p>
            <p className="a-text">We bridge the gap between complex financial concepts and everyday understanding. Our courses are designed in Hindi and English, making them accessible to learners across India — from students to working professionals to homemakers.</p>
            <p className="a-text">We are not just a coaching platform. We are a community of learners, traders and investors growing together under the guidance of certified market educators.</p>
          </div>
          <div className="a-section-right">
            <div className="a-highlight">
              <div className="a-highlight-icon">📚</div>
              <div>
                <div className="a-highlight-title">Education First</div>
                <div className="a-highlight-desc">We teach before we trade. Every concept is explained from basics to advanced with real market examples.</div>
              </div>
            </div>
            <div className="a-highlight">
              <div className="a-highlight-icon">🏛️</div>
              <div>
                <div className="a-highlight-title">SEBI & NISM Aligned</div>
                <div className="a-highlight-desc">Our curriculum follows SEBI guidelines and prepares students for NISM & NCFM certifications.</div>
              </div>
            </div>
            <div className="a-highlight">
              <div className="a-highlight-icon">👥</div>
              <div>
                <div className="a-highlight-title">Community Driven</div>
                <div className="a-highlight-desc">Join a growing community of traders and investors sharing insights, ideas and opportunities.</div>
              </div>
            </div>
            <div className="a-highlight">
              <div className="a-highlight-icon">📈</div>
              <div>
                <div className="a-highlight-title">Live Market Practice</div>
                <div className="a-highlight-desc">Learn with real market data. Practice trading in live sessions guided by our educators.</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* THREE PILLARS */}
      <section className="a-pillars">
        <div className="a-pillars-inner">
          <div className="a-tag" style={{textAlign:'center'}}>What we do</div>
          <h2 className="a-title" style={{textAlign:'center', marginBottom:'2rem'}}>Three Pillars of Our Platform</h2>
          <div className="a-pillars-grid">
            <div className="a-pillar">
              <div className="a-pillar-num">01</div>
              <h3 className="a-pillar-title">Learn</h3>
              <p className="a-pillar-desc">Structured courses from stock market basics to advanced derivatives, options and portfolio management. Taught in simple language with real examples.</p>
            </div>
            <div className="a-pillar">
              <div className="a-pillar-num">02</div>
              <h3 className="a-pillar-title">Trade</h3>
              <p className="a-pillar-desc">Live trading sessions, chart analysis, technical setups and intraday strategies. Learn to read the market and make confident trading decisions.</p>
            </div>
            <div className="a-pillar">
              <div className="a-pillar-num">03</div>
              <h3 className="a-pillar-title">Invest</h3>
              <p className="a-pillar-desc">Long-term wealth creation through fundamental analysis, portfolio building, mutual funds and equity investing guided by SEBI principles.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CERTIFICATIONS */}
      <section className="a-section a-certs">
        <div className="a-section-inner" style={{display:'block'}}>
          <div className="a-tag">Certifications</div>
          <h2 className="a-title">SEBI & NISM Recognised Courses</h2>
          <p className="a-cert-intro">We prepare students for globally recognised market certifications issued by SEBI's designated bodies — NISM and NCFM (NSE). These certifications validate your market knowledge and open doors to professional careers in finance.</p>
          <div className="a-cert-grid">

            {/* NCFM */}
            <div className="a-cert-box">
              <div className="a-cert-header">
                <div className="a-cert-badge">NCFM</div>
                <div className="a-cert-org">National Stock Exchange of India (NSE)</div>
              </div>
              <div className="a-cert-item">
                <div className="a-cert-dot"></div>
                <div>
                  <div className="a-cert-name">Capital Market Module</div>
                  <div className="a-cert-desc">Covers equity market structure, trading mechanisms, order types, settlement & clearing and market regulations for aspiring dealers.</div>
                </div>
              </div>
              <div className="a-cert-item">
                <div className="a-cert-dot"></div>
                <div>
                  <div className="a-cert-name">Options Trading Strategies</div>
                  <div className="a-cert-desc">Options pricing, Greeks, hedging strategies, spreads and practical options trading setups for consistent profitability.</div>
                </div>
              </div>
              <div className="a-cert-item">
                <div className="a-cert-dot"></div>
                <div>
                  <div className="a-cert-name">Technical Analysis Module</div>
                  <div className="a-cert-desc">Chart patterns, candlestick analysis, indicators, support & resistance, price action and building a complete trading system.</div>
                </div>
              </div>
              <div className="a-cert-item">
                <div className="a-cert-dot"></div>
                <div>
                  <div className="a-cert-name">Fundamental Analysis Module</div>
                  <div className="a-cert-desc">Financial statements, ratio analysis, company valuation methods and identifying fundamentally strong stocks.</div>
                </div>
              </div>
            </div>

            {/* NISM */}
            <div className="a-cert-box">
              <div className="a-cert-header">
                <div className="a-cert-badge">NISM</div>
                <div className="a-cert-org">SEBI — National Institute of Securities Markets</div>
              </div>
              <div className="a-cert-item">
                <div className="a-cert-dot"></div>
                <div>
                  <div className="a-cert-name">Series VIII — Equity Derivatives</div>
                  <div className="a-cert-desc">Futures & options on equities, index derivatives, risk management and regulatory framework. Mandatory for derivatives dealers.</div>
                </div>
              </div>
              <div className="a-cert-item">
                <div className="a-cert-dot"></div>
                <div>
                  <div className="a-cert-name">Series VII — Security Operations & Risk Management</div>
                  <div className="a-cert-desc">Trade lifecycle, clearing, settlement, risk controls and compliance in securities markets.</div>
                </div>
              </div>
              <div className="a-cert-item">
                <div className="a-cert-dot"></div>
                <div>
                  <div className="a-cert-name">Series I — Currency Derivatives</div>
                  <div className="a-cert-desc">Foreign exchange markets, currency futures & options, hedging strategies and regulatory aspects of currency trading in India.</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* FOUNDER */}
      <section className="a-section a-founder">
        <div className="a-section-inner">
          <div className="a-founder-left">
            <div className="a-avatar">HK</div>
            <div className="a-founder-info">
              <div className="a-tag">Founder</div>
              <h2 className="a-founder-name">Himanshu Kumar</h2>
              <div className="a-founder-role">Market Educator · NISM Certified · IRDAI Certified</div>
              <p className="a-text">Himanshu Kumar is a NISM certified market educator with over 5 years of hands-on trading and teaching experience. He founded The Atharva Veda Equity to democratise financial education in India — making stock market knowledge accessible, practical and profitable for everyone.</p>
              <div className="a-tags">
                <span className="a-tag-pill">Technical Analysis</span>
                <span className="a-tag-pill">Price Action</span>
                <span className="a-tag-pill">Options Trading</span>
                <span className="a-tag-pill">Risk Management</span>
                <span className="a-tag-pill">NISM Certified</span>
                <span className="a-tag-pill">IRDAI Certified</span>
                <span className="a-tag-pill">Portfolio Building</span>
                <span className="a-tag-pill">Mutual Funds</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* QUOTE */}
      <section className="a-quote-section">
        <div className="a-quote-inner">
          <div className="a-quote-card">
            <div className="a-q-mark">"</div>
            <p className="a-q-text">Markets reward patience and knowledge. I built this platform to give you both — one lesson, one trade, one decision at a time. Whether you are a complete beginner or an experienced trader looking to level up, The Atharva Veda Equity is your partner in building lasting financial success.</p>
            <div className="a-q-author">— Himanshu Kumar, Founder</div>
          </div>
        </div>
      </section>

    </div>
  );
}

export default About;